import { Outlet } from 'react-router-dom'

const ServiceBooking = () => <Outlet />

export default ServiceBooking
